// extracted by mini-css-extract-plugin
export default {"root":"hlXNI3","bg":"FwquDC"};